// @vendors
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
const moment = require('moment');
const momentTz = require('moment-timezone');


// @actions
const errorActions = require('actions/brokerError');
const signaturePatternActions = require('actions/signaturePattern');
const { mifidDisclaimersResponse } = require('actions/brokerRightsBuy');

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const {
    DATE_FORMAT_API,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_DISCRIMINADOR_CLAUSULA,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    DATE_FORMAT_WITH_DASHES_DATETIME,
    BROKER_ORDER_TYPE_SELL,
    BROKER_CORPORATE_OPERATIONS_VENTA_ACCIONES_PRODUCT_TYPE,
    CONNECTION_CHANNEL_INTERNET,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');

// @constants
const actionTypes = require('constants/actionTypes');

const PURCHASE_STOCKS_AGENT_ID = 'WEB';

const start = (cuenta, operation, contract, owner, associatedAccount, walletAccountType, isLoaded) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_START,
        payload: {
            cuenta,
            operation,
            contract,
            owner,
            associatedAccount,
            walletAccountType,
            isLoaded
        }
    });
};

const setOperationIndex = (index) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_SET_OPERATION_INDEX,
        payload: { index }
    });
}

const changeTitlesAmount = (titles) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_CHANGE_TITLES_AMOUNT,
        payload: { titles }
    });
};

const changeManifest = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_CHANGE_MANIFEST,
        payload: {}
    });
};

const validateStep = (step) => (dispatch) => {
    dispatch({
            type: actionTypes.BROKER_STOCKS_SALE_ORDER_VALIDATE,
            payload: { step }
        });
};

const setStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_SET_VISIBLE_STEP,
        payload: { step }
    });
};

const successOperation = (response) => {
    return {
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_FINISH,
        payload: {
            orderNumber: response.numeroOrden
        }
    };
};

const fetchPerformOperation = () => {
    return {
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_LOADING
    };
};

const failedOperation = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_STOCKS_SALE_ORDER_CONFIRM_FAILURE
    });
};

const storeDocument = (stocksSaleOrderResponse, history) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const immBrokerStocksSaleOrder = getState().brokerStocksSaleOrder;
    const immBrokerProductFile = getState().brokerProductFile;

    const immContract = immCorporatesOperations.get('selectedContract');
    const immOperation = immBrokerStocksSaleOrder.get('operation');

    const orderId = trim(get(stocksSaleOrderResponse, 'numeroOrden'));
    const orderTimestamp =
        get(stocksSaleOrderResponse, 'timestamp') ||
        get(stocksSaleOrderResponse, 'timeResponse.timestamp');

    const momentEmittedDateTime = momentTz(Number(orderTimestamp)).tz("Europe/Madrid");

    const controlDigit = trim(immContract.getIn(['cuenta', 'digitodecontrol']));
    const productNumber = trim(immContract.getIn(['contract', 'product']));
    const contractNumber = trim(immContract.getIn(['contract', 'number']));
    const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;

    const owner = trim(immContract.get('owner'));
    const momentEndDate = moment(immOperation.get('endDate'));

    const marketName = trim(immBrokerProductFile.get('marketName'));
    const sharesAmount = immBrokerStocksSaleOrder.getIn(['steps', FIRST_STEP, 'amount']);
    const unitPrice = immBrokerProductFile.getIn(['productValue', 'amount'], 0);
    const sharesNumber = unitPrice ? Math.floor(sharesAmount / unitPrice) : 0;

    const query = {
        productKID: '',
        contract: '',
        marketingReport: '',
        infoCcv: '',
        sendOrder: 'No',
        idOrder: orderId,
        market: marketName,
        termValidity: momentEndDate.format(DATE_FORMAT_API),
        holders: owner,
        leafletSusbcription: trim(immOperation.get('linkTriptico')),
        cnmvDocumentation: trim(immOperation.get('linkCNMV')),
        ccv: idContract,
        ccc: trim(get(stocksSaleOrderResponse, 'cuentaAsociada.codbban')),
        idContract: idContract,
        email: trim(PersonalDataHelper.getEmail(immProfile)),
        clientAlias: trim(immProfile.get('nombreCliente')),
        isin: trim(immOperation.get('isin')),
        isinDescribe: trim(immOperation.get('descriptionValue')),
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: BROKER_ORDER_TYPE_SELL,
        productType: BROKER_CORPORATE_OPERATIONS_VENTA_ACCIONES_PRODUCT_TYPE,
        sharesNumber: sharesNumber,
        sharesAmount,
        orderCondition: '',
        conditionPrize : '',
        currency: '',
        mifidWarningText: '',
        dateTime: momentEmittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    const url = apiURLBuilder.getURL('communication');

    APIPost(dispatch, url, { query }).catch(() => dispatch(errorActions.show('', true, history)));
}

const performOperation = (dispatch, getState, token, validationResponse, history) => {
    const immBrokerStocksSaleOrder = getState().brokerStocksSaleOrder;
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const immBrokerProductFile = getState().brokerProductFile;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const immOperation = immBrokerStocksSaleOrder.get('operation');
    const immContract = immBrokerStocksSaleOrder.get('contract');
    const immAssociatedAccount = immBrokerStocksSaleOrder.get('associatedAccount');
    const initQuantity = immBrokerStocksSaleOrder.getIn(['steps', FIRST_STEP, 'titlesAmount'], 0);
    const unitPrice = immBrokerProductFile.getIn(['productValue', 'amount'], 0);
    const productManager = immBrokerProductFile.get('companyName', '');

    const url = apiURLBuilder.getURL('brokerConfirmOPA');

    const requestObject = {
        header: {
            version: 2
        },
        query: {
            claseMarcaje: get(validationResponse, 'claseMarcaje'),
            codigoEmision: immOperation.get('codigoEmision'),
            codigoGrupoSector: get(validationResponse, 'codigoGrupoSector'),
            codigoValorInterno: immOperation.get('codigoValorInterno'),
            contrato: {
                numerodecontrato: immContract.get('number'),
                producto: immContract.get('product')
            },
            dataToken: token,
            digitoCuentaValores: immBrokerStocksSaleOrder.get('digitodecontrol'),
            importeMovimiento: {
                divisa: immAssociatedAccount.getIn(['balance', 'currency']),
                importe: immBrokerStocksSaleOrder.getIn(['steps', FIRST_STEP, 'titlesAmount']),
            },
            subtipoProceso: immOperation.get('subtipoProceso'),
            tipoMercado: get(validationResponse, 'tipoMercado'),
            tipoProceso: immOperation.get('tipoProceso'),
            agentId: PURCHASE_STOCKS_AGENT_ID,
            convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
            disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
            evaluateRegistry: mifidWasApplied,
            initQuantity: initQuantity,
            marketTargetRegistry: mifidScore >= mifidScoring,
            micCode:  trim(immOperation.get('iso')),
            necessaryConvenienceTestNote: mifidScoring,
            necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
            productIsin: trim(immOperation.get('isin')),
            productManager: productManager,
            productType: BROKER_ALERT_BUY_BUTTON_STOCK,
            reduceRisk: '',
            shares: initQuantity,
            testConveniencyResult: mifidScore,
            unitPrice: unitPrice,
            documentationId: uuid
        }
    };

    APIPost(dispatch, url, requestObject)
        .then((response) => {
            dispatch(successOperation(response));
            dispatch(storeDocument(response, history));
        })
        .catch((error) => {
            dispatch(failedOperation());
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
        })
};

const validateSignature = (dispatch, getState, validationResponse, history) => {
    const isAlreadyFetching = getState().brokerStocksSaleOrder.getIn(['steps', SECOND_STEP, 'loading']);

    if (!isAlreadyFetching) {
        dispatch(fetchPerformOperation());
        signaturePatternActions.validateAndExecute(
            dispatch,
            getState,
            (dispatch, getState, token) => performOperation(dispatch, getState, token, validationResponse, history)
        );
    }
};

const validate = (dispatch, getState, history) => {
    const immBrokerStocksSaleOrder = getState().brokerStocksSaleOrder;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const selectedContract = immCorporatesOperations.get('selectedContract');
    const immOperation = immBrokerStocksSaleOrder.get('operation');
    const immContract = immBrokerStocksSaleOrder.get('contract');
    const immAssociatedAccount = immBrokerStocksSaleOrder.get('associatedAccount');

    const url = apiURLBuilder.getURL('brokerFinancialOperationsValidation');

    const requestData = {
        codigoEmision: immOperation.get('codigoEmision'),
        codigoValorInterno: immOperation.get('codigoValorInterno'),
        contrato: {
            numerodecontrato: immContract.get('number'),
            producto: immContract.get('product')
        },
        discriminadorClausula: BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_DISCRIMINADOR_CLAUSULA,
        descripcionSubproceso: immOperation.get('descriptionProcess').trim(),
        fechaInicioOperacion: immOperation.get('startDate'),
        saldoCuentaAsociada: {
            divisa: immAssociatedAccount.getIn(['balance', 'currency']),
            importe: immAssociatedAccount.getIn(['balance', 'amount']),
        },
        cuentaAsociada: {
            codbban: selectedContract.getIn(['associatedAccount', 'number']),
            digitodecontrol: immBrokerStocksSaleOrder.get('digitodecontrol'),
            pais:  selectedContract.getIn(['associatedAccount', 'pais']),
        },
        tipoProceso: immOperation.get('tipoProceso'),
        subtipoProceso: immOperation.get('subtipoProceso'),
        tipoMercado: immOperation.get('iso'),
        links: [
            {
                href: selectedContract.getIn(['links', 'pais']),
                rel: '',
                templated: true,
            }
        ],
    };

    APIPost(dispatch, url, { query: requestData })
        .then((response) => {
            validateSignature(dispatch, getState, response, history)
        })
        .catch((error) => {
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
        })
}

const finishOperationPerforming = () => ({
    type: actionTypes.BROKER_STOCKS_SALE_ORDER_FINISH_VALIDATION_STARTED
});

const finish = (history) => (dispatch, getState) => {
    const error = getState().signaturePattern.get('showWarningSMS');
    const valid = getState().brokerStocksSaleOrder.getIn(['steps', SECOND_STEP, 'valid']);
    const alreadyValidating = getState().brokerStocksSaleOrder.get('validatingOperation');

    dispatch(finishOperationPerforming());
    if(error) {
        dispatch(failedOperation());
    } else if(valid && !alreadyValidating) {
        validate(dispatch, getState, history);
    }
};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_STOCKS_SALE_ORDER_DOCUMENTS_READ
});

module.exports = {
    start,
    changeTitlesAmount,
    setOperationIndex,
    changeManifest,
    validateStep,
    setStep,
    finish,
    setDocumentsRead
};
